import Overview from "./views/Overview/Overview.js";
// import ModelingInputs from "./views/Modeling/ModelingInputs.js";
// ``Inputs`` agora e' um router que escolhe entre InputsV2 e InputsV3
// conforme a feature flag ``inputs_v3`` da implementacao. O menu
// lateral exibe um unico item ``/inputs`` que serve as duas geracoes.
import Inputs from "./views/Modeling/Inputs";
import InputsV3 from "./views/Modeling/InputsV3";
import ExchangeRates from "./views/Modeling/ExchangeRates";
import Documentation from "./views/Modeling/Documentation.js";
import DownloadsCenter from "./views/Modeling/DownloadsCenter";
import PLExplorer from "./views/Results/PLExplorer";
import GraphExplorer from "./views/Results/GraphExplorer";
import MonthlyPL from "./views/Results/MonthlyPL";
// import ForecastVsActual from "./views/Results/ForecastVsActual";
import LogisticsFlow from "./views/Results/LogisticsFlow";
import Trends from "./views/Results/Trends";
import Indicators from "./views/Results/Indicators";
import Login from "./views/Login/Login.js";
import Initiatives from "./views/Governance/Initiatives.js";
import AlignmentSession from "./views/Governance/AlignmentSession.js";
import UserManagement from "./views/Admin/AccessManagement/AccessManagement";
import Adjustments from "./views/Admin/Adjustments";
import Groups from "./views/Admin/Groups";
import TermsOfUse from "./views/Extras/TermsOfUse";
import NoPermission from "./views/NoPermission/NoPermission";
import ContactPage from "./views/Extras/ContactPage";
import PasswordRecovery from "./views/Login/PasswordRecovery.js";

import OverviewIcon from "@material-ui/icons/FilterHdr";
import ModelingIcon from "@material-ui/icons/Dashboard";
import ResultsIcon from "@material-ui/icons/Equalizer";
import AdminIcon from "@material-ui/icons/Settings";
import CancelIcon from "@material-ui/icons/Cancel";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import ExploreIcon from "@material-ui/icons/Explore";
import PasswordReset from "./views/Login/PasswordReset.js";
import CTSGuidePortal from "./views/CTSGuide/CTSGuidePortal";
import Methodology from "./views/CTSGuide/Learning/Methodology";
import BestPractices from "./views/CTSGuide/Learning/BestPractices";
import DataRequest from "./views/CTSGuide/Learning/DataRequest";
import CriteriaLibrary from "./views/CTSGuide/Learning/CriteriaLibrary";
import PLRegistration from "./views/CTSGuide/Building/PLRegistration";
import DataTracking from "./views/CTSGuide/Building/DataTracking";
import CTSDocumentation from "./views/CTSGuide/Building/Documentation";
import BusinessIcon from "@material-ui/icons/Business";

const extrasRoutes = [
  {
    collapse: true,
    name: "sidebar_cts.extras",
    icon: MoreHorizIcon,
    state: "ExtrasCollapse",
    layout: "/extras",
    views: [
      {
        path: "/contact",
        name: "sidebar_cts.extras_menu.contact",
        mini: "sidebar_cts.extras_menu_mini.contact",
        component: ContactPage,
        layout: "/extras",
      },
      {
        path: "/terms-of-use",
        name: "sidebar_cts.extras_menu.terms_of_use",
        mini: "sidebar_cts.extras_menu_mini.terms_of_use",
        component: TermsOfUse,
        layout: "/extras",
      },
      {
        external_link: "https://integrationconsulting.com/en/privacy-policy/",
        name: "sidebar_cts.extras_menu.privacy_policy",
        mini: "sidebar_cts.extras_menu_mini.privacy_policy",
        layout: "/extras",
      },
    ],
  },
];

function deepClone(obj) {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map(deepClone);
  }
  const clonedObj = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      clonedObj[key] = deepClone(obj[key]);
    }
  }
  return clonedObj;
}

function changeLayoutToMain(obj) {
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      if (key === "layout") {
        obj[key] = "/main";
      } else if (typeof obj[key] === "object" && obj[key] !== null) {
        changeLayoutToMain(obj[key]);
      }
    }
  }
}

const extrasRoutesInMain = deepClone(extrasRoutes);
changeLayoutToMain(extrasRoutesInMain);

const dashRoutes = [
  {
    path: "/overview",
    name: "sidebar_cts.overview",
    icon: OverviewIcon,
    component: Overview,
    layout: "/main",
    allowedRoles: ["DEV", "IMG", "CAD", "CST", "CFA", "CVW", "CPV"],
    requiredPermission: "overview.view",
  },
  {
    collapse: true,
    name: "sidebar_cts.modeling",
    icon: ModelingIcon,
    state: "modelingCollapse",
    layout: "/main",
    allowedRoles: ["DEV", "IMG", "CAD", "CST", "CFA", "CIF", "CIP"],
    requiredAnyPermission: [
      "modeling.inputs.view",
      "modeling.exchange_rates.view",
      "modeling.documentation.view",
      "modeling.downloads.view",
    ],
    views: [
      {
        path: "/inputs",
        name: "sidebar_cts.modeling_menu.inputs",
        mini: "sidebar_cts.modeling_menu_mini.inputs",
        component: Inputs,
        layout: "/main",
        allowedRoles: ["DEV", "IMG", "CAD", "CST", "CFA", "CIF", "CIP"],
        requiredPermission: "modeling.inputs.view",
      },
      // Rota legada do V3 mantida apenas para navegacao programatica
      // (ex.: ``DecisionsToolbarItem`` ainda envia para ``/main/inputs_v3``
      // ao clicar no badge de decisoes pendentes). ``hidden: true`` evita
      // que o item apareca no menu — a entrada visivel e' a ``/inputs``
      // logo acima, que faz o roteamento V2/V3 conforme a feature flag.
      {
        path: "/inputs_v3",
        component: InputsV3,
        layout: "/main",
        allowedRoles: ["DEV", "IMG", "CAD", "CST", "CFA", "CIF", "CIP"],
        requiredFeatures: ["inputs_v3"],
        requiredPermission: "modeling.inputs.view",
        hidden: true,
      },
      {
        path: "/exchange_rates",
        name: "sidebar_cts.modeling_menu.exchange_rates",
        mini: "sidebar_cts.modeling_menu_mini.exchange_rates",
        component: ExchangeRates,
        layout: "/main",
        allowedRoles: ["DEV", "IMG", "CAD", "CST", "CFA", "CIF", "CIP"],
        requiredPermission: "modeling.exchange_rates.view",
      },
      {
        path: "/documentation",
        name: "sidebar_cts.modeling_menu.documentation",
        mini: "sidebar_cts.modeling_menu_mini.documentation",
        component: Documentation,
        layout: "/main",
        enableAIChat: true,
        allowedRoles: ["DEV", "IMG", "CAD", "CST", "CFA", "CIF", "CIP"],
        requiredPermission: "modeling.documentation.view",
      },
      {
        path: "/downloads",
        name: "sidebar_cts.modeling_menu.downloads",
        mini: "sidebar_cts.modeling_menu_mini.downloads",
        component: DownloadsCenter,
        layout: "/main",
        requiredPermission: "modeling.downloads.view",
      },
    ],
  },
  {
    collapse: true,
    name: "sidebar_cts.results",
    icon: ResultsIcon,
    state: "resultsCollapse",
    layout: "/main",
    allowedRoles: ["DEV", "IMG", "CAD", "CST", "CFA", "CVW", "CPV"],
    requiredPermission: "results.view",
    views: [
      {
        path: "/pl-explorer",
        name: "sidebar_cts.results_menu.pl_explorer",
        mini: "sidebar_cts.results_menu_mini.pl_explorer",
        component: PLExplorer,
        layout: "/main",
        enableAIChat: true,
        requiredPermission: "results.view",
      },
      {
        path: "/graph-explorer",
        name: "sidebar_cts.results_menu.graph_explorer",
        mini: "sidebar_cts.results_menu_mini.graph_explorer",
        component: GraphExplorer,
        layout: "/main",
        enableAIChat: true,
        requiredPermission: "results.view",
      },
      {
        path: "/monthly-pl",
        name: "sidebar_cts.results_menu.monthly_pl",
        mini: "sidebar_cts.results_menu_mini.monthly_pl",
        component: MonthlyPL,
        layout: "/main",
        enableAIChat: true,
        requiredPermission: "results.view",
      },
      // {
      //   path: "/forecast-vs-actual",
      //   name: "sidebar_cts.results_menu.forecast_vs_actual",
      //   mini: "sidebar_cts.results_menu_mini.forecast_vs_actual",
      //   component: ForecastVsActual,
      //   layout: "/main",
      //   enableAIChat: true,
      //   allowedRoles: ["DEV"],
      // },
      {
        path: "/logistics-flow",
        name: "sidebar_cts.results_menu.logistics_flow",
        mini: "sidebar_cts.results_menu_mini.logistics_flow",
        component: LogisticsFlow,
        layout: "/main",
        allowedRoles: ["DEV", "IMG", "CAD", "CST", "CFA"],
        requiredFeatures: ["logistics_flow"],
      },
      {
        path: "/trends",
        name: "sidebar_cts.results_menu.trends",
        mini: "sidebar_cts.results_menu_mini.trends",
        component: Trends,
        layout: "/main",
        allowedRoles: ["DEV", "IMG", "CAD", "CST", "CFA", "CVW", "CPV"],
        requiredPermission: "results.view",
      },
      {
        path: "/indicators",
        name: "sidebar_cts.results_menu.indicators",
        mini: "sidebar_cts.results_menu_mini.indicators",
        component: Indicators,
        layout: "/main",
        allowedRoles: ["DEV"],
        requiredFeatures: ["indicators"],
      },
    ],
  },
  {
    collapse: true,
    name: "sidebar_cts.governance",
    icon: ExploreIcon,
    state: "actionPlansCollapse",
    layout: "/main",
    allowedRoles: ["DEV", "IMG", "CAD", "CST", "CFA", "CVW", "CPV"],
    requiredPermission: "governance.view",
    views: [
      {
        path: "/alignment-session",
        name: "sidebar_cts.action_plans_menu.alignment_session",
        mini: "sidebar_cts.action_plans_menu_mini.alignment_session",
        component: AlignmentSession,
        layout: "/main",
        allowedRoles: ["DEV", "IMG", "CAD"],
        requiredPermission: "governance.alignment.create_session",
      },
      {
        path: "/initiatives",
        name: "sidebar_cts.action_plans_menu.initiatives",
        mini: "sidebar_cts.action_plans_menu_mini.initiatives",
        component: Initiatives,
        layout: "/main",
        requiredPermission: "governance.view",
      },
    ],
  },
  {
    collapse: true,
    name: "sidebar_cts.admin",
    icon: AdminIcon,
    state: "AdminCollapse",
    allowedRoles: ["CAD", "IMG", "DEV"],
    requiredPermission: "admin.view",
    layout: "/main",
    views: [
      {
        path: "/user-management",
        name: "sidebar_cts.admin_menu.user_management",
        mini: "sidebar_cts.admin_menu_mini.user_management",
        component: UserManagement,
        layout: "/main",
        disabled: false,
        requiredPermission: "admin.users.manage",
      },
      {
        path: "/adjustments",
        name: "sidebar_cts.admin_menu.adjustments_list",
        mini: "sidebar_cts.admin_menu_mini.adjustments_list",
        component: Adjustments,
        layout: "/main",
        disabled: false,
        allowedRoles: ["DEV", "CAD"],
        requiredPermission: "admin.adjustments.manage",
      },
      {
        path: "/groups",
        name: "sidebar_cts.admin_menu.groups",
        mini: "sidebar_cts.admin_menu_mini.groups",
        component: Groups,
        layout: "/main",
        disabled: false,
        allowedRoles: ["DEV"],
      },
    ],
  },
  {
    path: "/no-permission",
    name: "sidebar_cts.no_permission",
    icon: CancelIcon,
    component: NoPermission,
    layout: "/main",
    allowedRoles: ["NON"],
  },
  {
    path: "/login",
    name: "Profit InSights",
    component: Login,
    layout: "/auth",
  },
  {
    path: "/password-recovery",
    name: "password_recovery",
    component: PasswordRecovery,
    layout: "/auth",
  },
  {
    path: "/password-reset",
    name: "password_reset",
    component: PasswordReset,
    layout: "/auth",
  },
  ...extrasRoutes,
  ...extrasRoutesInMain,
  {
    collapse: true,
    name: "sidebar_cts.internal",
    icon: BusinessIcon,
    state: "internalCollapse",
    layout: "/main",
    allowedRoles: ["DEV", "IMG"],
    views: [
      {
        path: "/cts-guide",
        name: "sidebar_cts.cts_guide_portal",
        mini: "sidebar_cts.internal_menu_mini.cts_guide",
        component: CTSGuidePortal,
        layout: "/main",
      },
      // Hidden routes for mini nav navigation
      {
        path: "/cts-methodology",
        component: Methodology,
        layout: "/main",
        hidden: true,
      },
      {
        path: "/cts-best-practices",
        component: BestPractices,
        layout: "/main",
        hidden: true,
      },
      {
        path: "/cts-data-request",
        component: DataRequest,
        layout: "/main",
        hidden: true,
      },
      {
        path: "/cts-criteria-library",
        component: CriteriaLibrary,
        layout: "/main",
        hidden: true,
      },
      {
        path: "/cts-pl-registration",
        component: PLRegistration,
        layout: "/main",
        hidden: true,
      },
      {
        path: "/cts-data-tracking",
        component: DataTracking,
        layout: "/main",
        hidden: true,
      },
      {
        path: "/cts-documentation",
        component: CTSDocumentation,
        layout: "/main",
        hidden: true,
      },
    ],
  },
];
export default dashRoutes;
